import { makeStyles } from 'tss-react/mui'
export const useStyles = makeStyles()(theme => ({
  noOfContract: {
    fontSize: '14px !important',
  },
}))
